import React, { useRef } from 'react';
import MediaAssets from './MediaAssets';
import { ArrowFull } from '../../../../../static/icons/arrowFull';
import colors from '../../../../../tailwind.colors';

const Slider = ({ media, small, handleDataLayer, thumbSize }) => {
  const sliderRef = useRef(null);
  const scrollAmount = 600;

  const showSlider = media?.length > 1;

  return (
    <div className="flex justify-center items-center py-3">
      {showSlider && (
        <button
          type="button"
          onClick={() => {
            const container = sliderRef.current;
            container.scrollLeft -= scrollAmount;
          }}
          className="w-8 h-8 min-w-8 border-2 border-primary-800 rounded-full flex justify-center items-center global-hover"
        >
          <ArrowFull color={colors.primary[800]} />
          <span className="sr-only" id="close-modal">
            Previous
          </span>
        </button>
      )}
      <div
        ref={sliderRef}
        className={`flex items-center mx-2  max-w-[940px] ${
          !showSlider ? 'overflow-y-hidden' : 'overflow-x-auto'
        } scroll-smooth transition duration-300 ease-in-out`}
      >
        <MediaAssets
          media={media}
          mediaLength={media?.length}
          small={small}
          thumbSize={thumbSize}
          slider={showSlider}
          handleDataLayer={handleDataLayer}
        />
      </div>
      {showSlider && (
        <button
          type="button"
          onClick={() => {
            const container = sliderRef.current;
            container.scrollLeft += scrollAmount;
          }}
          className="w-8 h-8 min-w-8 border-2 border-primary-800 rounded-full flex justify-center items-center global-hover"
        >
          <ArrowFull direction="right" color={colors.primary[800]} />
          <span className="sr-only" id="close-modal">
            Next
          </span>
        </button>
      )}
    </div>
  );
};

export default Slider;
